import React from 'react';
import { useParams } from 'react-router-dom';
import { GinRummyGameUI, Game, User, UserComputer, Statistics } from 'gin-rummy-game-ui'
import { AppContext } from '../AppContext';

const GameController = (props) => {
    const app = React.useContext(AppContext);
    let { level, mode } = useParams();
    const phaserGameRef = React.useRef(null);
    const gameRef = React.useRef(null);


    //https://www.devauthority.com/react/using-pixi-js-with-react-functional-components-hooks/
    //https://stackoverflow.com/questions/75710343/react-18-and-pixijs-7
    React.useEffect(() => {
        const createGame = async () => {
            if (phaserGameRef.current) {
                return;
            }


            //Create Users - note: could be done on the app layer

            let user1 = new UserComputer("Player", 1, "", "Human");
            let user2 = new UserComputer("Joey", -1, "", level, 600);
            if (mode === "Test") {
                let delay = 30;
                user1 = new UserComputer("Player", 1, "", "Test", 30);
                user2 = new UserComputer("Joey", -1, "", level, delay);
            }

            //Create Game Core - note: could be done on the app layer
            let game = new Game();
            game.joinGame(user1);
            game.joinGame(user2);
            game.startGame();
            game.on("roundStageChanged", (data) => {
                const roundStage = game.gameState.roundStage;
                if (roundStage === "gameOver") {
                    saveStats(game.gameState);
                }
            });


            //Create Game UI
            let gameUI = new GinRummyGameUI();
            await gameUI.create("game-canvas1", null, null);
            await gameUI.loadGame(game, user1);


            gameRef.current = game;
            phaserGameRef.current = gameUI;


        }
        createGame();
        return () => {
            if (!phaserGameRef.current) return;
            phaserGameRef.current.destroy(true);
            phaserGameRef.current = null;
        };
    }, []);

    //save state function
    const saveStats = (gameState) => {

        const userdata = app?.userdata || {};
        const statistics = new Statistics();
        statistics.updateMatchStats(userdata, gameState);
        //app.save()

        //check for achievements
        app.achievements.checkForAchievementAndReward(app.userdata, app.userdata);

    }

    return (

        <div id="Game" className="page noAnimate activePage">
            <div className="gamePageWrapper" >
                <div className="pageTitle" style={{ flex: "0 1 auto" }}>
                    <a className="backButton" href="#"></a>
                </div>
                <div id="game-canvas1" className="gameDiv" style={{ flex: " 1 1 auto" }}>
                </div>
            </div>
        </div>
    )
};

export default GameController;

